import React from 'react';

import * as S from './DifferentRoom.styles';
import * as SS from '../../../CancelFlow/CancelLeftBlock/CancellationBody/CancellationBody.styles';
import * as AS from '../RescheduleInfoBlock/EditGuestBlock/RoomInfoBlock/RoomInfoBlock.styles';

import IconSelector from '@ibibo/icon-selector';

const DifferentRoom = ({updateActiveTab, fareList, statusMsg, hasRefund, modifyAllowed, updatedHotelDetails}) => {
  const {roomName, roomAmenities, guestDetails, hotelImage=''} = updatedHotelDetails;
  const adultCount = guestDetails.no_of_adults; 
  const childCount = guestDetails.no_of_children;
  const roomCount = guestDetails.no_of_rooms;
  const paxText = `${adultCount} Adult${adultCount > 1 ? 's' : ''} ${childCount} Child${childCount > 1 ? 'ren' : ''}`;

  const onBtnClick = () => {
    if (hasRefund){
      updateActiveTab('refund');
    } else {
      updateActiveTab('pay');
    }
  }

  return(
    <S.RoomInfoMainWrap>
      {(statusMsg && <S.RoomInfoHeadWrap>
        <S.RoomInfoHeadText fontWeight={statusMsg.fw} fontSize={statusMsg.fs} color={statusMsg.cc}>{statusMsg.msg}</S.RoomInfoHeadText>
      </S.RoomInfoHeadWrap>) || null}

      <S.RoomInfoInnerWrap>
        <S.RoomInnerBlock>

          <S.RoomTypeInfoWrap>
            <S.RoomInfoWrap>
              <S.RoomTypeText>{roomName} x {roomCount}</S.RoomTypeText>
              <S.GuestBlock><IconSelector iconKey="guests" /><p>{paxText}</p></S.GuestBlock>
            </S.RoomInfoWrap>
            <S.RoomImgWrap>
              <S.RoomImg src={hotelImage} alt="room" />
            </S.RoomImgWrap>
          </S.RoomTypeInfoWrap>

          <AS.RoomAmenitiesWrap>
            {(roomAmenities.map(item => <AS.RoomAmenitieInnerWrap key={item}>
              <AS.RoomAmenityText>{item}</AS.RoomAmenityText>
            </AS.RoomAmenitieInnerWrap>)) || null}
          </AS.RoomAmenitiesWrap>
        </S.RoomInnerBlock>

        <S.RoomPriceInfoWrap>
          {fareList.map(item => <S.RoomPriceInnerWrap key={item.k}>
            <S.RoomPriceTextWrap>
              <S.RoomPriceText fontWeight={item.fw} fontSize={item.fs} color={item.cc}>{item.k}</S.RoomPriceText>
              {/* <S.RoomPriceSubText>New price is for a different room</S.RoomPriceSubText> */}
            </S.RoomPriceTextWrap>
            <S.RoomPriceText fontWeight={item.fw} fontSize={item.fs} color={item.cc}>{item.c}{item.v.toLocaleString('en-IN')}</S.RoomPriceText>
          </S.RoomPriceInnerWrap>)}
        </S.RoomPriceInfoWrap>
      </S.RoomInfoInnerWrap>

      <SS.CancelBtnWrap>
        <SS.BackOptionWrap onClick={() => updateActiveTab('details')}>
          <SS.BackOptionText>Back to Booking Details</SS.BackOptionText>
        </SS.BackOptionWrap>
        {(modifyAllowed && <SS.CancelButtonWrap onClick={onBtnClick}>
          <SS.CancelBtn>{hasRefund ? 'SELECT REFUND MODE' : 'PAY & CONFIRM'}</SS.CancelBtn>
          {(hasRefund && <SS.CancelInfoText>Refund will be sent to your chosen mode</SS.CancelInfoText>) || null}
        </SS.CancelButtonWrap>) || null}
      </SS.CancelBtnWrap>
    </S.RoomInfoMainWrap>
  );
}

export default DifferentRoom;